<template>
	<Modal :open="modalStatus" @close="showModal()" align="center" animatedEnterClass="fadeInDown" animatedLeaveClass="fadeOutUp">
		<transition enter-active-class="animated flipInX">
		<div class="alert alert-success mB-0 bgc-white c-green-500" style="margin: 0 auto; width: 500px;" role="alert" v-if="successStatus">
  			<h4 class="alert-heading">操作成功</h4>
 			<div class="text-center">
 				<i class="fa fa-check fa-4x mb-3 animated rotateIn"></i>
                <p>{{ msg }}</p>
            </div>
            <div class="bdT ta-c pT-20 pB-15">
            	<button type="submit" class="btn btn-secondary mR-10" @click="showModal()"><i class="fa fa-list"></i> 返回列表
        		</button>
        		<button type="submit" class="btn btn-success" @click="hideSuccess()"><i class="fa fa-plus-circle"></i> 继续操作
        		</button>
            </div>
		</div>
		</transition>
		<transition enter-active-class="animated flipInX">
			<component :is="componentLoader" :routeParams="routeParams" :routeQuery="routeQuery" @onClose="onClose" v-if="componentStatus"></component>
		</transition>
	</Modal>	
</template>

<script>
	export default {
		name: 'Popup',
		props: {
			component: {
				type: String,
				required: true
			},
            routeParams: {
                type: Object
            },
            routeQuery: {
                type: Object
            }
        },
        mounted () {
        	if (this.component) {
        		this.loadComponent()

        		this.$nextTick(function () {
        			this.modalStatus = true;
        		})
        		this.$nextTick(() => {
        		    this.$nextTick(() => {
                        if (document.querySelector('.modal-body > form')) {
                            document.querySelector('.modal-body > form').onsubmit = (event) => {
                                event.preventDefault();
                            }
                        }
                    });
                });
        	}
    	},
        computed: {
            componentLoader () {
                return () => import(`../../views/${this.component}`)
            }
        },
        methods: {
            loadComponent () {
                this.componentLoader()
            },
            showModal () {
                this.modalStatus = !this.modalStatus

                // 刷新页面
                if (this.successStatus) {
                    this.$store.dispatch('fireReloadEvent')
                }
            },
            onClose ({ showSuccess = false, msg = '操作成功' } = {}) {
                this.successStatus = showSuccess
                this.msg = msg
                
                if (this.successStatus) {
                    this.componentStatus = false
                } else {
                    this.modalStatus = false
                }
            },
            hideSuccess () {
                this.successStatus = false

                setTimeout(() => {
                    this.componentStatus = true
                }, 100)

                this.$store.dispatch('fireReloadEvent')
            }
        },
        data () {
            return {
                componentFile: 'testing.vue',
                modalStatus: false,
                successStatus: false,
                componentStatus: true,
                msg: ''
            }
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/popup/popup.vue